export type TokenPreviewType = 'heading' | 'body' | 'code';

export type AutoGeneratedTypographyToken = {
  token: string;
  title: string;
  shortTitle?: string;
};

export interface TypographyTokenGroup {
  id: string;
  title: string;
  description: string;
  previewType: TokenPreviewType;
  tokens: AutoGeneratedTypographyToken[];
}

export enum TypographyHierarchyType {
  Base = 'base',
  Token = 'token',
}
